import React, { useEffect } from 'react';
import './HP.css';

export default function HPFooter({ createCall, startHairCheck }) {
  return (
    <div id="hp-top-footer">
      <div id="hp-top-footer-wrap">
        <div className="hp-top-footer-company">
          <div id="hp-top-company">QROW LTE PRD.</div>
          <div id="hp-top-address">Located at Singapore</div>
          <div id="hp-top-copy">© 2022 QROW LST PLD.</div>
        </div>
        <div className="hp-top-footer-area">
          <div className="hp-top-footer-item-title">Product</div>
          <div className="hp-top-footer-item">About</div>
          <div className="hp-top-footer-item">Price</div>
          <div className="hp-top-footer-item">Play Video</div>
          <div className="hp-top-footer-item">FAQ</div>
        </div>
        <div className="hp-top-footer-area">
          <div className="hp-top-footer-item-title"> Contact </div>
          <div className="hp-top-footer-item">Contact</div>
          <div className="hp-top-footer-item">Presskit</div>
          <div className="hp-top-footer-item">Twitter</div>
        </div>
        <div className="hp-top-footer-area">
          <div className="hp-top-footer-item-title">Terms</div>
          <div className="hp-top-footer-item">Terms</div>
          <div className="hp-top-footer-item">Privacy Policy</div>
        </div>
      </div>
    </div>
  );
}
